import { deleteMyRenderPreviewAPI, updateMyRenderPreviewApi } from "../api/commonApi";
import { myRenderPreviewActions, myRenderPreviewSelectors } from "../redux/slicers/render_preview/myRenderPreviewSlice";

import { MODEL_TYPES } from "../constants/constants"
import { apiRetryRenderPreview } from "../helpers/api";
import { useDispatch } from "react-redux";
import { useDownloadEntity } from "./useDownloadEntity"
import { useModelActions } from "./useModelActions";
import { useState } from "react";

export const useRenderPreviewsActions = ({ item }) => {
  const dispatch = useDispatch();
  const { download, loading: downloadLoading, download3DFilesZip } = useDownloadEntity();
  const [retryLoading, setRetryLoading] = useState(false);

  const label = item.is_upload
    ? 'upload'
    : item.is_preview
      ? 'preview'
      : 'render';

  const deleteTitle = item.is_main_render
    ? 'Are you sure you want to archive this render?'
    : `Are you sure you want to delete this ${label}?`;

  const deleteDescription = item.is_main_render
    ? 'You can view the archived renders through filter panel.'
    : 'Deleted items will be moved to trash.';

  const cancelButtonText = item.is_main_render ? "Cancel" : "Cancel";
  const okButtonText = item.is_main_render ? "Archive" : "Delete";
  const okBtnColor = "warning";
  const cancelBtnColor = "secondary";
  const okBtnClassName = item.is_main_render ? "lf-btn-3" : undefined;
  const deleteSuccessMessage = item.is_main_render ? 'Archived successfully' : 'Deleted successfully';

  const { favouriteLoading, onFavouriteToggle, onDelete, onShare, addToCollection , requestTo3DFilesCollection } = useModelActions({
    item,
    modelType: MODEL_TYPES.PROJECTRENDER,
    selectors: myRenderPreviewSelectors,
    updateApi: updateMyRenderPreviewApi,
    deleteSuccessMessage: deleteSuccessMessage,
    deleteConfig: {
      title: deleteTitle,
      description: deleteDescription,
      deleteApi: deleteMyRenderPreviewAPI,
      cancelButtonText,
      buttonText: okButtonText,
      okBtnColor,
      cancelBtnColor,
      okBtnClassName
    },
  });


  // const onLinkClick = () => {
  //   if (item.images.length !== 0) {
  //     dispatch(setRenderPreviewExpand(item));
  //   } else {
  //     errorToast("This Preview does not have a camera image.");
  //   }
  // }

  // const onDelete = (id) => {
  //   openInfoDialog({
  //     title: "Are you sure you want to archive this render?",
  //     description: `You can view the archived renders by clicking on the left pane of this screen`,
  //     cancelButtonText: "No",
  //     buttonText: "Yes",
  //     onButtonClick: () => {
  //       dispatch(deleteRenderPreviewAPI({ id }));
  //     },
  //   });


  // }


  const onDownloadClick = () => {
    download({ id: item.id, type: 'renders-previews', name: `${item?.name}.zip` , item:item })
  }

  const onRetry = async (id) => {
    setRetryLoading(true);
    console.log("onRetry id", id);
    const res = await apiRetryRenderPreview(id);
    if (res.status) {
      dispatch(myRenderPreviewActions.update(res.data));
    }
    setRetryLoading(false);
  }

  return {
    // onLinkClick,
    retryLoading,
    onRetry,
    downloadLoading,
    onDownloadClick,
    favouriteLoading,
    onFavouriteToggle,
    onDelete,
    onShare,
    addToCollection,
    requestTo3DFilesCollection,
    download3DFilesZip,
  }
}

